module.exports = __webpack_public_path__ + "static/media/aa12.b1d0ff03.jpg";